// src/hooks/useFilterOptions.js
import { useState, useEffect } from 'react';
import salesService from '../services/salesService';

export const useFilterOptions = () => {
  const [availableClosers, setAvailableClosers] = useState([]);
  const [availableOfferTypes, setAvailableOfferTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Define loadFilterOptions function outside useEffect so it can be reused
  const loadFilterOptions = async () => {
    try {
      setLoading(true);
      setError(null);
      
      // Call the sales service methods directly
      const [closersResponse, offerTypesResponse] = await Promise.all([
        salesService.getAvailableClosers(),
        salesService.getAvailableOfferTypes()
      ]);
      
      // Add 'all' option to closers
      const closersWithAll = ['all', ...closersResponse.closers];
      setAvailableClosers(closersWithAll);
      
      // Add 'all' option to offer types
      const offerTypesWithAll = [
        { id: 'all', label: 'All' },
        ...offerTypesResponse.offer_types
      ];
      setAvailableOfferTypes(offerTypesWithAll);
      
    } catch (error) {
      console.error('Error loading filter options:', error);
      setError(error.message || 'Failed to load filter options');
      
      // Fallback to default options on error
      setAvailableClosers(['all', 'ryan', 'rhino', 'james']);
      setAvailableOfferTypes([
        { id: 'all', label: 'All' },
        { id: 'mn3k', label: 'MN3K' },
        { id: 'mm5k', label: 'MM5K' },
        { id: 'mm7k', label: 'MM7K' },
        { id: 'ws15k', label: 'WS15K' },
        { id: 'ws20k', label: 'WS20K' },
        { id: 'ws25k', label: 'WS25K' }
      ]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadFilterOptions();
  }, []);

  // Helper function to refresh the options (useful for when new closers/offers are added)
  const refreshOptions = () => {
    loadFilterOptions();
  };

  return {
    availableClosers,
    availableOfferTypes,
    loading,
    error,
    refreshOptions
  };
};